import { customAlphabet } from "nanoid";
const nanoid = customAlphabet(
  "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_",
  12,
);
export function randomIdGenerator(prefix: string = ""): string {
  return prefix + nanoid(12);
}
